/** @jsxImportSource @emotion/react */
import { PUBLIC_ASSETS_BASE_URL } from '@app/app-constants'
import { SplashPage } from '@app/components/ui/SplashPage/SplashPage'
import { SplashBanner } from '@app/components/ui/SplashPage/SplashPageBanner'
import { selectedAssetIdAtom } from '@app/state/propertyAtoms'
import { Box, Button, Typography, useTheme } from '@mui/material'
import { useSetAtom } from 'jotai'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { PropertySuggestion } from '../types'
import {
  propertySearchButtonWrapper,
  propertySearchContainer,
  propertySearchInputWrapper,
  propertySearchRow,
  propertySearchTitle,
} from './PropertyLandingPage.style'
import { PropertySearch } from './PropertySearch'

export const PropertyLandingPage = () => {
  const theme = useTheme()
  const navigate = useNavigate()
  const propertyBannerImg = `${PUBLIC_ASSETS_BASE_URL}/images/shared/rex_property_hero.svg`
  const propertyLogoImg = `${PUBLIC_ASSETS_BASE_URL}/images/shared/rex_pex_home_logo.svg`
  const [selectedSuggestion, setSelectedSuggestion] = useState<PropertySuggestion | null>(null)

  const setSelectedAssetId = useSetAtom(selectedAssetIdAtom)

  const onHandleSearchProperty = () => {
    if (selectedSuggestion) {
      // Set the atom
      setSelectedAssetId(selectedSuggestion.asset_id)
      navigate(`/app/property/${selectedSuggestion.asset_id}`)
    }
  }

  return (
    <SplashPage>
      <SplashPage.Hero>
        <SplashBanner testId="property-splash-page-banner">
          <SplashBanner.Wrapper>
            <SplashBanner.LeftColumn>
              <SplashBanner.Logo src={propertyLogoImg} alt="Property - Resilience Explorer" />
              <SplashBanner.Headline>
                View and export natural hazard information for a property.
              </SplashBanner.Headline>
            </SplashBanner.LeftColumn>
            <SplashBanner.RightColumn>
              <SplashBanner.Image src={propertyBannerImg} alt="Property - Overview Image" />
            </SplashBanner.RightColumn>
          </SplashBanner.Wrapper>
        </SplashBanner>
      </SplashPage.Hero>
      <SplashPage.Content>
        <Box css={propertySearchContainer}>
          <Typography css={propertySearchTitle} variant="h4" component="h4">
            Find a Property
          </Typography>

          <Box css={propertySearchRow(theme)}>
            <Box css={propertySearchInputWrapper}>
              <PropertySearch onSuggestionSelected={setSelectedSuggestion} />
            </Box>

            <Box css={propertySearchButtonWrapper}>
              <Button
                variant="contained"
                onClick={onHandleSearchProperty}
                sx={{ height: '100%', flexShrink: 0 }}
                disabled={!selectedSuggestion}
              >
                Search
              </Button>
            </Box>
          </Box>
        </Box>
      </SplashPage.Content>
    </SplashPage>
  )
}
